export const isSearchableMentionNode = (node) => node.type.name === 'mention' || node.type.name === 'scriptMention';
export const getMentionSearchText = (node) => {
    if (!isSearchableMentionNode(node)) {
        return '';
    }
    const label = typeof node.attrs.label === 'string' ? node.attrs.label.trim() : '';
    const id = typeof node.attrs.id === 'string' ? node.attrs.id.trim() : '';
    const name = label || id;
    if (!name) {
        return '';
    }
    const suggestionChar = typeof node.attrs.mentionSuggestionChar === 'string' && node.attrs.mentionSuggestionChar
        ? node.attrs.mentionSuggestionChar
        : '@';
    return `${suggestionChar}${name}`;
};
//# sourceMappingURL=mention-search-text.js.map